import lodash from 'lodash-es'
import axios from 'axios'
import { SET_RESULTS, SET_FILTRED_RESULTS } from '../mutation-types'
const results = {
  namespaced: true,
  state: {
    results: [],
    filtredResults: [],
    isAllResultsSelected: false,
    isFilteredListSelected: false,
    pagination: {},
    selectedResults: [],
    limit: 15,
  },
  mutations: {
    [SET_RESULTS](state, data) {
      console.log('data SET_RESULTS = ', data)
      state.results = data.data
      state.pagination = lodash.get(data, 'meta.pagination', {})
    },
    [SET_FILTRED_RESULTS](state, data) {
      state.filtredResults = data
    },
  },
  actions: {
    getFailureResultsByClientId({ commit, rootState }, params = {}) {
      console.log('reseved params', params)
      let payload = {}
      payload.companyId = lodash.get(rootState, 'company.id', null)
      payload.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return axios
        .post(
          rootState.apiBaseURL + '/registrations-failures/' + rootState.user.id,
          payload,
          { params }
        )
        .then((response) => {
          console.log('response ', response)
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            let meta = response.data.meta
            commit('SET_RESULTS', { data: data, meta: meta })
            return data
          } else {
            throw new Error(
              'Impossible de récupérer la liste des résultats en échec'
            )
          }
        })
    },
    getResultsByClientId({ commit, rootState }, params = {}) {
      let payload = {}
      payload.companyId = lodash.get(rootState, 'company.id', null)
      payload.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return axios
        .post(
          rootState.apiBaseURL + '/registrations-results/' + rootState.user.id,
          payload,
          { params }
        )
        .then((response) => {
          console.log('response', response)
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            let meta = response.data.meta
            commit('SET_RESULTS', { data: data, meta: meta })
            return data
          } else {
            throw new Error(
              'Impossible de récupérer la liste des résultats en échec'
            )
          }
        })
    },
    searchResults({ commit, rootState }, { params = {} }) {
      let data = {
        companyId: lodash.get(rootState, 'company.id', null),
        establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return new Promise((resolve, reject) => {
        axios
          .post(
            rootState.apiBaseURL +
              '/registrations-results/' +
              rootState.user.id,
            data,
            {
              params,
            }
          )
          .then((response) => {
            let resp = []
            console.log('response = ', response)
            if (lodash.get(response, 'data.data')) {
              resp = response.data.data
              let data = response.data.data
              let meta = response.data.meta
              commit('SET_RESULTS', { data: data, meta: meta })
              commit('SET_FILTRED_RESULTS', resp)
            }
            resolve(resp)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    deleteRegistration({ rootState }, data = {}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(rootState.apiBaseURL + '/unsubscribe-register', { data })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteResults({ rootState }, data = {}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(rootState.apiBaseURL + '/results', { data })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  getters: {},
}
export default results
